export default __webpack_public_path__ + "f8f3d35908de6864ff8d6ea5f92d44da.png";